import { ASK_MAX_OTHER_LENGTH, } from "@repo/contract/agent";
/**
 * One widget's selections as the tool output (`askAnswersMatchQuestions`: one
 * answer per question, in order).
 *
 * The completeness check is over the WHOLE widget and it is a defence rather
 * than a message anyone normally reads — the confirm is disabled until every
 * question has an answer, and a single single-select question submits on the
 * tap with the value it was tapped with. It stays because the alternative to a
 * refusal here is a tool result the transport silently drops for the same
 * reason, which looks to the person like a tap that did nothing.
 */
export function widgetAnswers(input, selections, translate, 
/** `D191`: what the person typed into "Outro", one entry per question —
 *  counted only where the question allows it. */
others = []) {
    const typed = input.questions.map((question, index) => question.allowOther === true ? (others[index] ?? "").trim() : "");
    if (input.questions.some((_question, index) => (selections[index] ?? []).length === 0 && typed[index] === "")) {
        return {
            kind: "invalid",
            message: translate("chat.answer_every_question"),
        };
    }
    return {
        kind: "ready",
        output: {
            answers: input.questions.map((question, index) => widgetAnswer(question, selections[index] ?? [], typed[index] ?? "")),
        },
    };
}
/**
 * `labels` beside `values`, resolved from the question that was on screen —
 * the contract's own reason: the text was model-authored and exists nowhere
 * else, so a restored transcript could not recover it from a value.
 *
 * The `?? value` fallback cannot fire from the UI (a chip's value comes from
 * its own option) and is here for the one caller that could get it wrong.
 */
function widgetAnswer(question, values, typed) {
    const answer = {
        labels: values.map((value) => question.options.find((option) => option.value === value)?.label ??
            value),
        ...(typed === "" ? {} : { other: typed.slice(0, ASK_MAX_OTHER_LENGTH) }),
        values: [...values],
    };
    return question.step === undefined
        ? answer
        : { ...answer, step: question.step };
}
//# sourceMappingURL=answer.js.map